/**
 * PopupStorageService - Abstraction layer for popup storage
 * 
 * Implements Dependency Inversion Principle by providing an abstraction
 * over sessionStorage, making the code testable and decoupled from browser APIs.
 */
export class PopupStorageService {
    /**
     * Mark a popup as seen by storing it in session storage
     * @param {string|number} popupId - The ID of the popup
     */
    static markAsSeen(popupId) {
        sessionStorage.setItem(`popup_seen_${popupId}`, 'true');
    }

    /**
     * Check if a popup has been seen in this session
     * @param {string|number} popupId - The ID of the popup
     * @returns {boolean} - True if the popup has been seen
     */
    static hasBeenSeen(popupId) {
        return sessionStorage.getItem(`popup_seen_${popupId}`) !== null;
    }

    /**
     * Clear all popup tracking data (useful for testing)
     */
    static clearAll() {
        const keys = Object.keys(sessionStorage);
        keys.forEach(key => {
            if (key.startsWith('popup_seen_')) {
                sessionStorage.removeItem(key);
            }
        });
    }
}
